<template>
  <div class="un-pxtorem-advertisment">
    <div class="un-pxtorem-swiper">
      <van-swipe :autoplay="3000" indicator-color="white" :height="460">
        <van-swipe-item>
          <img fit="contain" src="../../icons/banner2.png" width="100%" height="100%"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="un-pxtorem-imgDiv">
      <img src="../../icons/ads2.png" alt="" >
      <img src="../../icons/ads3.png" alt="" >
      <img src="../../icons/ads1.png" alt="" >
    </div>
    
  </div>
</template>
<script>

export default {
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>
<style scoped>
.un-pxtorem-advertisment{
  background: #FAFBFC;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;height: 675px;padding:20px;
}
.un-pxtorem-swiper{
  border-radius: 6px;
  overflow: hidden;
  width:100%;height:460px
}
.van-swipe-item{
  background: #fff;
}
.un-pxtorem-advertisment /deep/ .van-swipe__indicator{
  width: 5px;
  height: 5px;
}
.un-pxtorem-imgDiv{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px
}
.un-pxtorem-imgDiv img{
  background: #fff;
  border-radius: 6px;
  width: 285px;
}
</style>
